<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title">名称</span>
        <el-input v-model="parameter.name" />
      </div>
      <div class="item">
        <span class="item_title" style="margin-right:10px">关键字</span>
        <el-input v-model="parameter.key_word" />
      </div>
      <div class="item">
        <span class="item_title">投放组</span>
        <el-autocomplete
          v-model="group_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="(parameter.group_id = null), (group_name = null)"
          @select="handleSelect"
        />
      </div>
      <!-- <div class="item">
        <span class="item_title">类型</span>
        <el-select
          v-model="parameter.type"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in [{label:'视频',value:'1'},{label:'图片',value:'2',disabled: true}]"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
          />
        </el-select>
      </div> -->
      <div class="item">
        <span class="item_title">日期</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <el-button style="height:37px" type="primary" icon="el-icon-search" @click="getDataList">搜索</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-refresh-left" @click="reset">重置</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-bottom" @click="reportExport">导出报表</el-button>
    </div>
    <div class="content1">
      <div>
        合计
      </div>
      <div>
        <div>消耗：</div>
        <div>{{ tableData.total_data && tableData.total_data.total_cost ? tableData.total_data.total_cost : 0 }}</div>
      </div>
    </div>
    <div>
      <el-table
        ref="tableRef"
        v-loading="loading"
        :data="tableData.list"
        max-height="650"
        style="width: 100%"
        border
        @sort-change="sortChange"
      >
        <el-table-column
          prop="stat_time_day"
          label="日期"
        />
        <el-table-column
          prop="name"
          label="名称"
        />
        <el-table-column
          prop="key_word"
          label="关键字"
        >
          <template scope="scope">
            <ExpandClose
              :my-values="[scope.row.key_word]"
            />
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="type"
          label="类型"
        >
          <template scope="scope">
            {{ scope.row.type===1?'视频':"图片" }}
          </template>
        </el-table-column> -->
        <el-table-column
          prop="stat_cost"
          label="消耗"
          sortable="custom"
        >
          <template scope="scope">
            <div>
              <span v-if="!(activeItem && activeItem.id === scope.row.id)">{{ scope.row.stat_cost }}</span>
              <input v-else v-model="activeText" type="number" autofocus style="width: 87px;padding: 5px;border: 1px solid #ccc;" @blur="blur1">
              <i v-if="!(activeItem && activeItem.id === scope.row.id)" class="el-icon-edit" style=" margin-left: 13px; font-size: 19px; cursor: pointer;" @click="(activeItem = scope.row),(activeText = scope.row.stat_cost)" />
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="effective_cost"
          label="有效消耗"
        /> -->
        <!-- <el-table-column
          prop="ctr"
          label="点击率"
        />
        <el-table-column
          prop="conversion_rate"
          label="转化率"
        />
        <el-table-column
          prop="conversion_cost"
          label="平均转化成本"
        /> -->
      </el-table>
      <pagination-right
        :total="tableData.count"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import { listMaterial_bind_groups, report_list, export_report, set_cost } from '@/api/enormousAmountMaterialReport.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import ExpandClose from '@/components/ExpandClose/index.vue'
export default {
  components: {
    PaginationRight,
    ExpandClose
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        pageSize: 10,
        name: null,
        key_word: null,
        group_id: null,
        type: ''
      },
      group_name: null,
      date: [this.getNowFormatDate(window.Date.now()), this.getNowFormatDate(window.Date.now())],
      activeItem: null,
      activeText: null,
      order_by: {} // 表格数据排序
    }
  },
  created() {
    window.aa = this
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      // // value为ture,从搜索按钮点击进入方法，清空排序
      // value && this.sortOrderChang()
      const data = await report_list({ ...this.parameter,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null,
        order_by: this.order_by && this.order_by.field && this.order_by.order ? this.order_by : null
      })
      this.tableData = data.data
      this.loading = false
    },
    // 投放组选搜索
    async querySearchAsync(queryString, cb) {
      const data = await listMaterial_bind_groups({
        name: queryString || null
      })
      cb(data.data.list.map((item) => {
        return {
          value: item.group_name,
          address: item.id
        }
      }))
    },
    // 选中哪一项
    handleSelect(item) {
      this.group_name = item.value
      this.parameter.group_id = item.address
    },
    // 分页
    fetchPageSize(s) {
      this.parameter.pageSize = s
      this.getDataList()
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },
    // 清空排序
    // sortOrderChang() {
    //   this.order_by = {}
    //   this.$refs.tableRef.clearSort()
    // },
    // 列表排序
    sortChange(cell) {
      this.order_by['order'] = !cell.order ? cell.order : cell.order === 'ascending' ? 'asc' : 'desc'
      this.order_by['field'] = !cell.order ? cell.order : 'stat_cost'
      this.getDataList()
    },
    // 重置
    reset() {
      this.parameter = {
        page: 1,
        pageSize: 10,
        name: null,
        key_word: null,
        group_id: null,
        type: ''
      }
      this.group_name = null
      this.date = []
      this.order_by = {}
      this.$refs.tableRef.clearSort()
      this.getDataList()
    },
    async blur1() {
      if (this.activeItem.consume !== this.activeText) {
        try {
          await set_cost({ id: this.activeItem.id, cost: this.activeText })
          this.$message({
            message: '修改消耗成功',
            type: 'success'
          })
          this.getDataList()
        } catch (err) {
          this.activeItem = null
          this.activeText = null
        }
      }
      this.activeItem = null
      this.activeText = null
    },

    // 导出报表
    async reportExport() {
      await export_report({ ...this.parameter,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })
    },
    getNowFormatDate(timeStamp) {
      var date = new Date(timeStamp)
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    }

  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.content{
   .item{
     display: flex;
     align-items: center;
    .item_title{
       display: inline-block;
       width: 55px;
    }
    .item_input{
       width: 200px
    }
   }
}

.selectionArea{
  display: flex;
  flex-wrap: wrap;
  .item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title{
      width: 55px;
       display: inline-block;
    }
    .item_input{
      width:200px
    }
  }
}
.content1{
  padding: 13px;
  color: #000;
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
}
.content1>div:nth-child(1){
  margin-right: 7rem;
}
.content1>div{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 3rem;
}
.content1>div>div:nth-child(2){
  color: rgb(138, 37, 37);
}
</style>

